import script from "./tree.vue?vue&type=script&lang=ts&setup=true"
export * from "./tree.vue?vue&type=script&lang=ts&setup=true"

import "./tree.vue?vue&type=style&index=0&id=151dc824&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151dc824"]])

export default __exports__